import React from 'react';
import styled from '@emotion/styled';
import { OMGTheme } from '@ordermygear/theme';
import ItemImage from './ItemImage';
import ItemDescription from './ItemDescription';
import ItemStatus from './ItemStatus';
import ItemQuantity from './ItemQuantity';

const OneItem = styled.li`
  width: 100%;
  margin: auto;
  display: grid;
  grid-template-columns: ${(props: any)=> props.level === 'order' ? '1fr 1fr 1fr;' : '1fr 1fr 1fr 1fr;'}
  border: 1px solid ${OMGTheme.colors.grayLightBorder};
  border-top: 0px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 0;
  div {
    text-align: left;
    justify-self: center;
    align-self: center;
  }
  @media only screen and (max-width: ${OMGTheme.breakpoints.xs}) {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    border: 0px;
    padding: 0;
    div {
      height: 100px;
      line-height: 100px;
      border-bottom: 1px solid ${OMGTheme.colors.grayLightBorder};
      width: 100%;
    }
  }
`;

const Heading = styled.div`
  display: none;
  @media only screen and (max-width: ${OMGTheme.breakpoints.xs}) {
    display: block;
    padding-left: 10px;
    font-size: 14px;
    font-weight: 500;
    color: ${OMGTheme.colors.grayDark};
    text-align: left;
  }
}`;

interface OrderItemProps {
  level: string;
  image: string;
  name: string;
  attributes: any;
  status: string;
  statusDescription: string;
  statusColorHex: string;
  statusColorRgba: [number],
  quantity: number;
}

const OrderItem: React.FC<OrderItemProps> = ({
  level,
  image,
  name,
  attributes,
  status,
  statusDescription,
  statusColorHex,
  statusColorRgba,
  quantity
}) => {
  return (
    <OneItem level={level}>
      <Heading>Product Image</Heading>
      <ItemImage image={image} />
      <Heading>Product Details</Heading>
      <ItemDescription name={name} attributes={attributes} />
        {level === 'item' && (
          <>
            <Heading>Fulfillment Status</Heading>
            <ItemStatus status={status} statusDescription={statusDescription} statusColorHex={statusColorHex} statusColorRgba={statusColorRgba} />
          </>
        )}
      <Heading>Fulfillment Quantity</Heading>
      <ItemQuantity quantity={quantity} />
    </OneItem>
  );
};

export default OrderItem;